(function (app, ng) {
    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Resources.Surge",
            {
                url: "/Surge",
                component: "surge",
                PageTitle: "Surge Business Consulting",
                requiredPermissions: "Surge:View",
                resolve: {
                    states: ["states", function (states) {
                        return states;
                    }],                    
                    purchased: ["purchaseApi", "userApi", function (purchaseApi, userApi) {
                        var o = null;
                        return userApi.getLoggedInUser().then(function (user) {
                            return purchaseApi.getUserOrders(user.Id).then(function (orders) {
                                ng.forEach(orders, function (order) {
                                    if (order.MarketingStrategy === "SurgeBc") {                                      
                                        var d = new Date(order.CompletedDate);
                                        var n = d.toLocaleDateString();
                                        order.PurchaseDate = n;

                                        purchaseApi.getMarketingStrategyOfOrder(order.Id).then(function (strategy) {
                                            if (strategy.DocusignUrl != null)
                                                order.DocusignUrl = strategy.DocusignUrl;

                                            if (strategy.Image != null)
                                                order.Image = strategy.Image;
                                        });
                                        o = order;
                                    }
                                });
                                return o;
                            });
                        });
                    }],
                    capstone: ["purchaseApi", "userApi", function (purchaseApi, userApi) {
                        return purchaseApi.getMarketingStrategyByName("Capstone").then(function (strategy) {                        
                            return strategy;
                        });
                       
                    }]
                }
            });
        }
    ]);

    app.component("surge",
    {
        templateUrl: "App/Resources/Surge/surge.html",
        controller: surgeCtrl,
        bindings: {
            states: "<",
            purchased: "<",
            capstone: "<"
        }
    });

    surgeCtrl.$inject = ["eligibilityFormDialog", "surveys", "eligibilityFormApi", "purchaseApi", "$mdDialog", "wistiaApi", "permissionService", "$filter", "userApi", "$interval", "amplitudeService"];

    function surgeCtrl(eligibilityFormDialog, surveys, eligibilityFormApi, purchaseApi, $mdDialog, wistiaApi, permissionService, $filter, userApi, $interval, amplitudeService) {
        var $ctrl = this;

        $ctrl.logAmplitude = function (propertyName) {
            return amplitudeService.logClickEvent(propertyName);
        };

        $ctrl.intervals = [];
      
        surveys.then(function (s) {
            eligibilityFormApi.isEnrolled(s.surgeId).then(function (response) {
                $ctrl.submitted = response;
            });
        });

        $ctrl.verifyPurchased = function () {
            var o = null;
            return userApi.getLoggedInUser().then(function (user) {
                return purchaseApi.getUserOrders(user.Id).then(function (orders) {
                    ng.forEach(orders, function (order) {
                        if (order.MarketingStrategy === "SurgeBc") {
                            var d = new Date(order.CompletedDate);
                            var n = d.toLocaleDateString();
                            order.PurchaseDate = n;

                            purchaseApi.getMarketingStrategyOfOrder(order.Id).then(function (strategy) {
                                if (strategy.DocusignUrl != null)
                                    order.DocusignUrl = strategy.DocusignUrl;
                                if (strategy.Image != null)
                                    order.Image = strategy.Image;
                            });
                            o = order;                                      
                        }
                    });

                    if (o != null) {
                        ng.forEach($ctrl.intervals, function (interval) {
                            $interval.cancel(interval);
                        });
                        $ctrl.purchased = o;
                    } 
                });
            });                   
        }             
        
        $ctrl.loadResources = function () {
            $ctrl.loadingAssets = true;
            wistiaApi.getSurgeAssets().then(function (response) {
                var projectMedias = response.medias;
                $ctrl.Assets = [];

                var uniqueMedias = $filter("unique")(projectMedias, "section");
                ng.forEach(uniqueMedias, function (value, key) {
                    var newAsset =
                    {
                        Title: value.section,
                        Active: uniqueMedias.length > 1 ? true : false,
                        Medias: ($filter("filter")(projectMedias, { section: value.section }))
                    }
                    $ctrl.Assets.push(newAsset);
                });
            }).then($ctrl.loadingAssets = false);
        }

        /*  Open the Enrollment Form  */
        $ctrl.openDialog = function (event) {
            surveys.then(function (s) {
                eligibilityFormDialog.open(event, s.surgeId).then(function (obj) {
                    ng.extend($ctrl, obj);
                });
            });
        }

        $ctrl.openPurchaseDialog = function (event) {

            $mdDialog.show({
                bindToController: true,
                controllerAs: "$ctrl",
                controller: dialogCtrl,
                templateUrl: "App/Resources/PurchasePage/template.html",
                parent: ng.element(document.body),
                targetEvent: event,
                clickOutsideToClose: false,
                locals: {
                    orders: purchaseApi.getAllOrders(),
                    title: "Surge Business Consulting",
                    purchaseOptions: [{ Description: "Business Consulting - One Time Payment", Amount: 5000 }],
                    termsLink: "https://www.figmarketing.com/Documents/Terms_of_Use.pdf",
                    marketingDollars: purchaseApi.getMarketingDollars().then(function (response) {
                        return response.MarketingDollarsTotal;
                    }).catch(ng.noop)
                }
            }).then(function (paymentAmount) {
                if (paymentAmount > 0) {
                    //TODO: AP - Lets come up with a better way to verify the purchase after paytrace executed

                    $ctrl.intervals.push(
                        $interval(function () {
                            $ctrl.verifyPurchased();
                        }, 3000)
                    );
                }
                else $ctrl.verifyPurchased();               
            });
        }
        if (permissionService.hasOnePermission("Surge:Access")) {
            $ctrl.loadResources();
        }


    }

    dialogCtrl.$inject = ["$mdDialog", "purchaseApi", "$window", "$state", "userApi"];
    function dialogCtrl($mdDialog, purchaseApi, $window, $state, userApi) {
        var $ctrl = this;

        ng.extend($ctrl,
            {
                close: close,
                cancel: cancel,
                purchase: purchase,
                getPaymentAmount: getPaymentAmount,
                setup: setup
            });

        function setup() {
            $ctrl.selectedPurchaseOption = 0;
            $ctrl.paymentAmount = $ctrl.purchaseOptions[0].Amount;
            $ctrl.marketingDollarsToUse = 0;
        }

        $ctrl.setup();
    
        function getPaymentAmount() {
            if ($ctrl.marketingDollarsToUse > $ctrl.marketingDollars) {
                $ctrl.marketingDollarsToUse = $ctrl.marketingDollars;
            }
            if ($ctrl.marketingDollarsToUse > $ctrl.purchaseOptions[($ctrl.selectedPurchaseOption)].Amount) {
                $ctrl.marketingDollarsToUse = $ctrl.purchaseOptions[($ctrl.selectedPurchaseOption)].Amount;
            }

            if ($ctrl.marketingDollarsToUse == null || $ctrl.marketingDollarsToUse < 0) {
                $ctrl.marketingDollarsToUse = 0;
            }

            $ctrl.paymentAmount = $ctrl.purchaseOptions[($ctrl.selectedPurchaseOption)].Amount - $ctrl.marketingDollarsToUse;
        }  

        function purchase(model) {
            $ctrl.submittingOrder = true;
            $ctrl.error = false;
            var order = { Description: model.Description };
            order.PaymentAmount = $ctrl.paymentAmount;
            order.MarketingDollarsUsed = $ctrl.marketingDollarsToUse;
            order.MarketingStrategy = "SurgeBc";
            order.Total = $ctrl.purchaseOptions[$ctrl.selectedPurchaseOption].Amount;          
            if (!!$ctrl.purchaseOptions[($ctrl.selectedPurchaseOption)].IsRecurringPayment)
                order.Frequency = "3";
            else
                order.Frequency = "0";
           
            return purchaseApi.purchase(order)
                .then(function (response) {
                  
                    $ctrl.submittingOrder = false; 
                    close($ctrl.paymentAmount);

                    if ($ctrl.paymentAmount > 0) {
                        $window.open(response, "_blank");
                        //$window.location.href = "/";
                    }
                }).catch(function (error) {
                    console.log(error);
                    $ctrl.submittingOrder = false;
                    $ctrl.error = true;
                });
        }

        function close(paymentAmount) {          
            $mdDialog.hide(paymentAmount); 
        }

        function cancel() {
            $mdDialog.cancel();
        }
    };
})(window.app, window.angular); // jshint ignore:line